import HttpClient from "./http-client";

export default class ExtraPayService {
  #client;

  constructor(token) {
    this.#client = HttpClient({ token });
  }

  async getCardByUser(username) {
    const response = await this.#client.get(`/extrapay/getcardbyuser/${username}`);

    return response.data;
  }

  async getConversionsByUser(username) {
    const response = await this.#client.get(`/extrapay/getconversionbyuser/${username}`);

    return response.data;
  }

  async convertUserWalletValue(payload) {
    const response = await this.#client.post(`/extrapay/convert`, payload);

    return response.data;
  }
}


